import { gql } from '@apollo/client';
export const TEAM_FUNDRAISING_CREATE_MUTATION = gql `
  mutation TeamFundraisingCreate($data: TeamFundraisingCreateInput!) {
    team: teamFundraisingCreate(data: $data) {
      id
    }
  }
`;
